// extracted by mini-css-extract-plugin
export default {"button-container":"Button_button-container__i19tf","btn-shiny":"Button_btn-shiny__ajgoM","shine":"Button_shine__NCiJU"};